import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function WorkflowIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M14.7273 11L16 12.2353L11.0909 17L8 14L9.27273 12.7647L11.0909 14.5294L14.7273 11Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 3H2V1H12C14.2091 1 16 2.79086 16 5C16 7.20914 14.2091 9 12 9H4C2.89543 9 2 9.89543 2 11C2 12.1046 2.89543 13 4 13H7V15H4C1.79086 15 0 13.2091 0 11C0 8.79086 1.79086 7 4 7H12C13.1046 7 14 6.10457 14 5C14 3.89543 13.1046 3 12 3Z"
        />
        <path d="M4 2C4 3.10457 3.10457 4 2 4C0.89543 4 0 3.10457 0 2C0 0.89543 0.89543 0 2 0C3.10457 0 4 0.89543 4 2Z" />
        <path d="M10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8Z" />
      </svg>
    </Icon>
  );
}
